import { QueryConfig } from "store/utils/query-config";

export const igMediasDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["metaData.createdTime"]
  }
};
